import axios from "core/axios";

export default {
  getViews: (timezone: string) => {
    return axios.get(`/users/getVisits?timeZone=${timezone}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
  getViewsUsersPreviews: (ids: Array<number>) => {
    const tempSet = new Set(ids);
    const tempArr = Array.from(tempSet)
    const query = tempArr.map((el) => `idVisits=${el}`).join("&");
    return axios.get(`/users/getVisitsPreviewInfo?${query}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  readVisits: (ids: Array<number>) => {
    const tempSet = new Set(ids);
    const tempArr = Array.from(tempSet)
    const query = tempArr.map((el) => `idVisits=${el}`).join("&");
    return axios.put(`/users/readVisits?${query}`, {}, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  }
};
